import TransactionItemModule from './transaction-item.module'

export default TransactionItemModule
